import { Preference } from '@app/core/model/user-preferences.interface'
import { TableColumnKey } from '../../ui-components/scope-ui-table/table-column-key.enum'

export const getMainDepartmentColumns = (): Preference[] => [
  {
    key: TableColumnKey.DEPARTMENT_NAME,
    name: 'DEPARTMENT',
    selected: true,
    isVisibleInList: () => false,
    field: 'name',
  },
]
